









































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import { CicloPlanejamentoParmDTO } from '@/interfaces/crm-planning-cycle';
import * as service from '@/services/crm-planning-cycle';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { UiDatePicker }
})
export default class PlanningCycleForm extends BaseComponent {
  @Prop()
  id: number;

  modalOpen = false;

  dto: any = {
    automatico: false
  };

  public form: any = {
    valid: false,
    rules: {
      data: [(v) => !!v || 'Informe a Data de Corte']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (this.id == null) {
      setTimeout(() => {
        this.modalOpen = true;
      }, 50);
    }
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }

    this.loader.start('Carregando ...');
    service.getCrmPlanningCycle(id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.modalOpen = true;
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Processando ...');

    let parm = new CicloPlanejamentoParmDTO();
    parm.id = this.dto.id;
    parm.automatico = this.dto.automatico;
    parm.dataCorte = this.dto.dataCorte;
    parm.aberto = this.dto.aberto;

    service.updateCrmPlanningCycle(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Ciclo alterado com sucesso', 'success');
        this.$emit('afterSave');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }
}
